package net.scalytica.blaargh

import io.circe._
import io.circe.generic.extras.semiauto._
import io.circe.generic.extras.defaults.defaultGenericConfiguration

package object models {

  implicit val siteConfigDecoder: Decoder[Config] = deriveConfiguredDecoder
  implicit val authorDecoder: Decoder[Author] = deriveConfiguredDecoder
  implicit val ownerDecoder: Decoder[Owner] = deriveConfiguredDecoder

  implicit val articleDecoder: Decoder[Article] = deriveConfiguredDecoder
}



// WEBPACK FOOTER //
// /Users/kpm/Development/scalytica/renslebraten.no/_project/src/main/scala/net/scalytica/blaargh/models/package.scala